/* Daily Smile: snel toevoegen aan winkelwagen.
   Werkt voor elke knop met data-ds-add en data-variant-id.
   Opent daarna de standaard Horizon winkelwagen-lade via CartAddEvent. */
import { CartAddEvent } from '@theme/events';


/* Ronde 9: Pop en spetter op de knop, daarna vliegt een mini product naar het mandje. Pas daarna opent de lade. */
const still = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
function spetter(btn) {
  if (still()) return;
  const r = btn.getBoundingClientRect();
  const s = document.createElement('span');
  s.className = 'ds-spetter';
  s.style.left = r.left + r.width / 2 + 'px';
  s.style.top = r.top + r.height / 2 + 'px';
  const card = btn.closest('[class*="ds-c-"]');
  if (card) s.style.setProperty('--c-acc', getComputedStyle(card).getPropertyValue('--c-acc'));
  for (let i = 0; i < 10; i++) {
    const d = document.createElement('i');
    d.style.setProperty('--a', i * 36 + 'deg');
    s.appendChild(d);
  }
  document.body.appendChild(s);
  setTimeout(() => s.remove(), 700);
}
function vlieg(btn) {
  return new Promise((done) => {
    const img = btn.closest('.ds-card, .ds-cross, .ds-addon')?.querySelector('img');
    const cart = [...document.querySelectorAll('cart-icon, .header-actions__cart-icon')].find((el) => el.getBoundingClientRect().width > 0);
    if (still() || !img || !cart || !img.animate) return done();
    const a = img.getBoundingClientRect();
    const b = cart.getBoundingClientRect();
    if (!a.width || b.bottom < 0) return done();
    const size = Math.min(a.width, 120);
    const k = img.cloneNode();
    k.removeAttribute('srcset');
    k.removeAttribute('sizes');
    k.removeAttribute('loading');
    k.className = 'ds-vlieg';
    Object.assign(k.style, { width: size + 'px', height: size + 'px', left: a.left + a.width / 2 - size / 2 + 'px', top: a.top + a.height / 2 - size / 2 + 'px' });
    document.body.appendChild(k);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = k.animate(
      [
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: `translate(${dx * 0.3}px, ${dy * 0.85 - 30}px) scale(.6) rotate(-14deg)`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(.15) rotate(-24deg)`, opacity: 0.7 },
      ],
      { duration: 700, easing: 'cubic-bezier(.22,.8,.24,1)' }
    );
    const end = () => { k.remove(); done(); };
    anim.onfinish = end;
    anim.oncancel = end;
    setTimeout(end, 1200);
  });
}

async function addToCart(btn) {
  const id = Number(btn.dataset.variantId);
  if (!id || btn.getAttribute('aria-busy') === 'true') return;
  btn.setAttribute('aria-busy', 'true');
  btn.dataset.state = 'busy';
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'cart');
    const cart = await fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    btn.dataset.state = 'added';
    spetter(btn);
    await vlieg(btn);
    document.dispatchEvent(
      new CartAddEvent(cart, 'ds-add-' + id, { source: 'ds-add', itemCount: cart.item_count, variantId: String(id) })
    );
    btn.dataset.state = 'added';
  } catch (e) {
    btn.dataset.state = 'error';
  } finally {
    btn.removeAttribute('aria-busy');
    setTimeout(() => {
      if (btn.dataset.state !== 'busy') delete btn.dataset.state;
    }, 2200);
  }
}

document.addEventListener('click', (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-ds-add]') : null;
  if (!btn) return;
  event.preventDefault();
  addToCart(btn);
});

/* Beloningsbalk: kort felicitatiemoment als je in deze sessie net een mijlpaal haalt (gratis verzending of cadeau).
   De balk wordt door Horizon opnieuw opgebouwd na elke wijziging, dus we kijken naar data-reached.
   Eerste meting in een sessie viert niets. Animatie staat uit bij prefers-reduced-motion (CSS). */
(() => {
  const KEY = 'ds-reached';
  const read = () => {
    try { return sessionStorage.getItem(KEY); } catch (e) { return null; }
  };
  const write = (v) => {
    try { sessionStorage.setItem(KEY, v); } catch (e) {}
  };
  let busy = false;
  const check = () => {
    busy = false;
    const bars = document.querySelectorAll('.ds-reward[data-reached]');
    if (!bars.length) return;
    const now = (bars[0].dataset.reached || '').split(' ').filter(Boolean);
    const before = read();
    write(now.join(' '));
    if (before === null) return;
    const had = before.split(' ');
    const fresh = now.filter((m) => !had.includes(m));
    if (!fresh.length) return;
    bars.forEach((bar) => {
      if (bar.classList.contains('is-party')) return;
      bar.dataset.party = fresh[fresh.length - 1];
      bar.classList.add('is-party');
      /* Laat de balk zien als de lade al naar beneden gescrold was */
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (bar.closest('dialog[open]')) bar.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
      setTimeout(() => bar.classList.remove('is-party'), 1800);
    });
  };
  const schedule = () => {
    if (!busy) { busy = true; requestAnimationFrame(check); }
  };
  const root = document.querySelector('cart-drawer-component') || document.querySelector('.ds-reward')?.parentElement;
  if (!root) return;
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  schedule();
})();
